module.exports = __webpack_public_path__ + "static/media/10.question.24a79a8a.mp4";